// @mui
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from '@mui/material/styles';
// hooks
import useResponsive from '../../hooks/useResponsive';
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------
export default function OfferIsFull() {
  const smUp = useResponsive('up', 'sm');

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2.5 },
        borderRadius: 2,
        backgroundColor: (theme) => alpha(theme.palette.warning.main, 0.08),
      }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={1}>
        <SvgIconStyle src={`/icons/icon-check-circle-mono.svg`} sx={{ color: "warning.darker" }} />
        <Stack>
          <Typography variant={smUp ? "subtitle1" : "subtitle2"} sx={{ color: "warning.darker", mb: 0.5 }}>
            대기열 안내
          </Typography>
          <Typography variant={smUp ? "body1" : "body2"} sx={{ color: "text.primary" }}>
            먼저 수락한 후보의 매칭이 진행되고 있어요.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  )
};
